import { Routes, Route } from 'react-router-dom'
import { useAuthStore } from './hooks/useAuthStore'
import { LoginPage } from './pages/LoginPage'
import { LineCallbackPage } from './pages/LineCallbackPage'
import { ProtectedRoute, ParentRoute, AdminRoute } from './components/ProtectedRoute'
import { ParentDashboard } from './pages/ParentDashboard'
import { PaymentPage } from './pages/PaymentPage'
import { LessonsPage } from './pages/LessonsPage'
import { ExpensesPage } from './pages/ExpensesPage'
import { ProfilePage } from './pages/ProfilePage'
import { InvoiceDetailPage } from './pages/InvoiceDetailPage'
import { PaymentSlipUploadPage } from './pages/PaymentSlipUploadPage'
import { PaymentSlipSuccessPage } from './pages/PaymentSlipSuccessPage'
import { AdminDashboard } from './pages/AdminDashboard'
import { AdminLessonPostPage } from './pages/AdminLessonPostPage'
import { AdminLessonsPage } from './pages/AdminLessonsPage'
import { AdminExpensesPage } from './pages/AdminExpensesPage'
import { AdminAttendancePage } from './pages/AdminAttendancePage'
import { AttendanceSuccessPage } from './pages/AttendanceSuccessPage'
import { LessonPostSuccessPage } from './pages/LessonPostSuccessPage'
import { AdminPaymentsPage } from './pages/AdminPaymentsPage'
import { AdminStudentsPage } from './pages/AdminStudentsPage'
import { PaymentRejectPage } from './pages/PaymentRejectPage'
import { PaymentRejectSuccessPage } from './pages/PaymentRejectSuccessPage'
import { DeleteConfirmPage } from './pages/DeleteConfirmPage'
import { DeleteSuccessPage } from './pages/DeleteSuccessPage'
import { CourseSelectionPage } from './pages/CourseSelectionPage'
import { EnrollmentFormPage } from './pages/EnrollmentFormPage'
import { EnrollmentPaymentPage } from './pages/EnrollmentPaymentPage'
import { CourseRenewalPage } from './pages/CourseRenewalPage'
import { LoadingSpinner } from './components/LoadingSpinner'
import { ErrorBoundary } from './components/ErrorBoundary'
import { NavigationAnnouncer } from './components/NavigationAnnouncer'

function App() {
  const { user, isLoading } = useAuthStore()
  
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <LoadingSpinner size="large" message="กำลังโหลด..." />
      </div>
    )
  }
  
  return (
    <ErrorBoundary>
      <div className="min-h-screen bg-gray-50 font-thai">
        <NavigationAnnouncer />
        
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/auth/line/callback" element={<LineCallbackPage />} />
          
          {/* Protected Parent Routes */}
          <Route path="/" element={
            <ParentRoute>
              <ParentDashboard />
            </ParentRoute>
          } />
          <Route path="/dashboard" element={
            <ParentRoute>
              <ParentDashboard />
            </ParentRoute>
          } />
          <Route path="/payment" element={
            <ParentRoute>
              <PaymentPage />
            </ParentRoute>
          } />
          <Route path="/lessons" element={
            <ParentRoute>
              <LessonsPage />
            </ParentRoute>
          } />
          <Route path="/expenses" element={
            <ParentRoute>
              <ExpensesPage />
            </ParentRoute>
          } />
          <Route path="/profile" element={
            <ParentRoute>
              <ProfilePage />
            </ParentRoute>
          } />
          <Route path="/invoice/:id" element={
            <ParentRoute>
              <InvoiceDetailPage />
            </ParentRoute>
          } />
          <Route path="/payment-slip/:invoiceId" element={
            <ParentRoute>
              <PaymentSlipUploadPage />
            </ParentRoute>
          } />
          <Route path="/payment-slip/success" element={
            <ParentRoute>
              <PaymentSlipSuccessPage />
            </ParentRoute>
          } />
          <Route path="/courses" element={
            <ParentRoute>
              <CourseSelectionPage />
            </ParentRoute>
          } />
          <Route path="/enrollment/new" element={
            <ParentRoute>
              <EnrollmentFormPage />
            </ParentRoute>
          } />
          <Route path="/enrollment/payment" element={
            <ParentRoute>
              <EnrollmentPaymentPage />
            </ParentRoute>
          } />
          <Route path="/enrollment/renew" element={
            <ParentRoute>
              <CourseRenewalPage />
            </ParentRoute>
          } />
          
          {/* Protected Admin Routes */}
          <Route path="/admin/dashboard" element={
            <AdminRoute>
              <AdminDashboard />
            </AdminRoute>
          } />
          <Route path="/admin/attendance" element={
            <AdminRoute>
              <AdminAttendancePage />
            </AdminRoute>
          } />
          <Route path="/admin/attendance/success" element={
            <AdminRoute>
              <AttendanceSuccessPage />
            </AdminRoute>
          } />
          <Route path="/admin/lessons" element={
            <AdminRoute>
              <AdminLessonsPage />
            </AdminRoute>
          } />
          <Route path="/admin/lessons/post" element={
            <AdminRoute>
              <AdminLessonPostPage />
            </AdminRoute>
          } />
          <Route path="/admin/lessons/success" element={
            <AdminRoute>
              <LessonPostSuccessPage />
            </AdminRoute>
          } />
          <Route path="/admin/lessons/:id/edit" element={
            <AdminRoute>
              <AdminLessonPostPage />
            </AdminRoute>
          } />
          <Route path="/admin/expenses" element={
            <AdminRoute>
              <AdminExpensesPage />
            </AdminRoute>
          } />
          <Route path="/admin/payments" element={
            <AdminRoute>
              <AdminPaymentsPage />
            </AdminRoute>
          } />
          <Route path="/admin/payments/reject" element={
            <AdminRoute>
              <PaymentRejectPage />
            </AdminRoute>
          } />
          <Route path="/admin/payments/reject/success" element={
            <AdminRoute>
              <PaymentRejectSuccessPage />
            </AdminRoute>
          } />
          <Route path="/admin/students" element={
            <AdminRoute>
              <AdminStudentsPage />
            </AdminRoute>
          } />
          <Route path="/admin/delete-confirm" element={
            <AdminRoute>
              <DeleteConfirmPage />
            </AdminRoute>
          } />
          <Route path="/admin/delete/success" element={
            <AdminRoute>
              <DeleteSuccessPage />
            </AdminRoute>
          } />
          
          {/* Default redirect - protected route will handle auth check */}
          <Route path="*" element={
            <ProtectedRoute>
              <ParentDashboard />
            </ProtectedRoute>
          } />
        </Routes>
      </div>
    </ErrorBoundary>
  )
}

export default App